export default __webpack_public_path__ + "static/media/tinder-clone.c2d69d31.png";